<div class="flex-carousel">
    <h2 class="flex-carousel__header" [innerHTML]="block.data.header"></h2>

    <div class="flex-carousel-slider" [swiper]="slideConfig">
        <div class="flex-carousel-slider__container">
            <div *ngFor="let block of block.content; trackBy: trackByFn;" class="flex-carousel-slider__item">
                <div class="flex-carousel-slider__content">
                    <blockquote class="flex-carousel-slider__blockquote">
                        <p class="flex-carousel-slider__quote-text" [innerHTML]="block.data.quote"></p>

                        <footer class="flex-carousel-slider__footer" *ngIf="block.data.cite">
                            <cite class="flex-carousel-slider__cite" *ngIf="block.data.cite">
                                <span *ngIf="!block.data.citeLink" [outerHTML]="block.data.cite"></span>
                                <a class="flex-carousel-slider__cite-link" *ngIf="block.data.citeLink" href="{{block.data.citeLink}}" [innerHTML]="block.data.cite"></a>
                            </cite>
                        </footer>
                    </blockquote>

                    <div class="flex-carousel-slider__image" [ngStyle]="{backgroundImage: block.data.image ? 'url(' + block.data.image + ')' : null}"></div>
                </div>
            </div>
        </div>

        <div class="flex-carousel-controls">
            <div class="flex-carousel-controls__prev"></div>
            <div class="flex-carousel-controls__indicator-wrapper"></div>
            <div class="flex-carousel-controls__next"></div>
        </div>
    </div>
</div>
